/* eslint-disable comma-dangle */
<template>
  <div class="wrapper">
    <div class="deck">
      <SmallCard v-for="value in decks.get(selectedDeck)" :key="value" :cardValue="value"/>
    </div>
  </div>
</template>

<script>
import SmallCard from './SmallCard.vue';
import { DECK_MAP, DECK_STANDARD } from '../data/deck';

export default {
  name: 'Deck',
  components: {
    SmallCard,
  },
  props: { deck: { default: 'standard' } },
  data() {
    return {
      decks: DECK_MAP,
    };
  },
  computed: {
    selectedDeck() {
      return this.deck || DECK_STANDARD;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>

.deck {
  padding: 20px 10px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 15px;
}

span {
  color: white;
}
</style>
